import gql from 'graphql-tag';

import mainDisplayObjectFragment from './mainDisplayObjectFragment';
import dokkioTagFragment from './dokkioTagFragment';
import dashboardDokkioLabelFragment from './dashboardDokkioLabelFragment';

export const dashboardClusterFragment = gql`
  fragment dashboardClusterFragment on DashboardCluster {
    dokkioClass
    id
    name
    summary
    importance
    icon
    effectiveWhatsNewSentence
    dashboardDokkioLabel {
      ...dashboardDokkioLabelFragment
    }
    dokkioTag {
      ...dokkioTagFragment
    }
    mainDisplayObjects {
      ...mainDisplayObjectFragment
    }
  }
  ${mainDisplayObjectFragment}
  ${dokkioTagFragment}
  ${dashboardDokkioLabelFragment}
`;
export default dashboardClusterFragment;
